import React from 'react';
import './DocumentUploadFields.scss';
import CheckBox from 'src/components/Checkbox';
import FileInput from 'src/components/File';
import FontAwesomeIcon from 'src/components/Icon';
import Input from 'src/components/Input';
import Textarea from 'src/components/Textarea';
import { variables } from 'src/Tenants';
import { DocumentFormData } from 'src/utils/S3UploadDocumentsUtility';

interface Props {
  formData: DocumentFormData;
  errorMessage: string;
  onSelectDocument: (files: any[]) => void;
  onUpdateFormData: (data: Partial<DocumentFormData>) => void;
  onClearFile: () => void;
  from?: string;
}

const DocumentUploadFields: React.FC<Props> = ({
  formData,
  errorMessage,
  onSelectDocument,
  onUpdateFormData,
  onClearFile,
  from,
}) => (
  <div className="offline-doc-form-right">
    <FileInput
      label={formData.type || 'Document'}
      documentType={formData.type}
      onSelect={onSelectDocument}
      files={
        formData.uploadType === 'Doc'
          ? []
          : formData.image
            ? formData.image
            : []
      }
      image={null}
      errors={errorMessage}
      required={true}
      disabled={!formData.type}
    />
    {formData.pendingFile && (
      <div className="offline-doc-form-file-preview">
        <label className="offline-doc-form-file-preview-label">
          {formData.pendingFile.name} (
          {(formData.pendingFile.size / 1024).toFixed(2)} KB)
        </label>
        <span
          className="offline-doc-form-file-preview-clear"
          onClick={onClearFile}
          title="Remove document"
        >
          <FontAwesomeIcon glyph="times-circle" weight="regular" size="small" />
        </span>
      </div>
    )}
    <Input
      value={formData.name ?? ''}
      onChange={(e: any) => onUpdateFormData({ name: e.target.value })}
      label={`${formData.type || 'Document'} Name`}
      placeholder={`${formData.type || 'Document'} Name`}
      block
      required={false}
    />
    <Textarea
      value={formData.description ?? ''}
      onChange={(e: any) => onUpdateFormData({ description: e.target.value })}
      label="Description"
      placeholder="Description"
      block
      required={false}
    />
    {from === 'propertyForm' && (
      <CheckBox
        checked={!!formData.docAvailability}
        value={!!formData.docAvailability}
        label={`Make it available at ${variables.suite} level`}
        onChange={() =>
          onUpdateFormData({ docAvailability: !formData.docAvailability })
        }
      />
    )}
  </div>
);

export default DocumentUploadFields;
